import { moveWindowToObj } from '../lib/lib'

class scrollToElement {
  constructor(element) {
    if (!element) {
      return false
    }

    this.link = jQuery(element)

    this.link.on('click', (event) => {
      event.preventDefault()

      // Get the target element ID from the data attribute
      const targetSelector = jQuery(this.link).data('scroll-to')

      // Find the target element by its ID
      const targetElement = document.querySelector(targetSelector)

      // Scroll to the target element smoothly
      if (targetElement) {
        moveWindowToObj(jQuery(targetElement))
      }
    })
  }
}

export default scrollToElement